import React, { Component, Fragment } from "react";
import { Modal } from 'antd';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle} from "@fortawesome/free-solid-svg-icons";

export const AlertModal =

class extends Component {
  render() {
    const title = this.props.noTitle ? <></> : <><FontAwesomeIcon icon={faExclamationCircle} size="2x" style={{color: "#FFCD07"}}/> {this.props.titulo}</>

		return <Modal
          title={title}
		      open={this.props.visible}
          onOk={this.props.handleClose}
          onCancel={this.props.handleClose}
          cancelButtonProps={{style: { display: 'none' }}}
          maskClosable = {false}
          centered
          width={this.props.width || 520}
        >
          {this.props.children}
        </Modal>
	}

}